/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Item_Unlinked_BadgeInputs */

const vi_kiotviet_item_unlinked_badge = /** @type {(inputs: Kiotviet_Item_Unlinked_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa nối`)
};

/**

* @param {Kiotviet_Item_Unlinked_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_item_unlinked_badge = /** @type {((inputs?: Kiotviet_Item_Unlinked_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Item_Unlinked_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_item_unlinked_badge(inputs)
});